import {
  AfterViewInit,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import AddressHelper from 'src/app/helpers/address-helper';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import ProjectMapHelper from 'src/app/helpers/project-map-helper';
import Address from 'src/app/model/project/address';
import { GeocoderService } from 'src/app/services/geocoder.service';
import { SubscriptionWithDestroyTriggerComponent } from 'src/app/subscription-helpers/subscription-with-destroy-trigger.component';
import { TourDetailTourItem } from '../helper/model/tour-detail-tour-item';
import {
  EmployeeTourMapHelper,
  EmployeeTourMapMarker,
} from './helper/employee-tour-map-helper';
import {
  CoordinateLike,
  EmployeeTourMapDirectionsCalculationService,
} from './service/employee-tour-map-directions-calculation.service';
import { NgMapsViewComponent } from '@ng-maps/core';
import { GoogleComponent } from '@ng-maps/google';

@Component({
  selector: 'employee-tour-map',
  templateUrl: './employee-tour-map.component.html',
  styleUrls: ['./employee-tour-map.component.scss'],
})
export class EmployeeTourMapComponent
  extends SubscriptionWithDestroyTriggerComponent
  implements OnInit, OnChanges, AfterViewInit
{
  @Input()
  items: TourDetailTourItem[];
  @Input()
  placerAddress: Address;

  INPRESS_COORDINATES = ProjectMapHelper.INPRESS_COORDINATES;
  HIDE_POI_STYLE = ProjectMapHelper.HIDE_POI_STYLE;

  @ViewChild(GoogleComponent, { static: true })
  agmMap: NgMapsViewComponent<any>;

  markers: EmployeeTourMapMarker[];
  totalDistance: string;

  private directionsRenderer = new google.maps.DirectionsRenderer({
    preserveViewport: true,
    suppressMarkers: true,
    suppressInfoWindows: true,
  });

  constructor(
    private employeeTourMapDirectionsCalculationService: EmployeeTourMapDirectionsCalculationService,
    private geocoderService: GeocoderService
  ) {
    super();
  }

  ngOnInit(): void {
    this.processSubProjects();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.items) {
      this.processSubProjects();
    }
  }

  private processSubProjects(): void {
    this.markers = EmployeeTourMapHelper.getEmployeeTourMapMarkers(
      this.items,
      true
    );

    this.directionsRenderer.setDirections({
      geocoded_waypoints: [],
      routes: [],
    });

    if (CollectionHelper.isPopulated(this.markers)) {
      this.renderDirections();
    }
  }

  private async renderDirections(): Promise<void> {
    let placerAddressCoordinates = null;
    try {
      placerAddressCoordinates =
        this.placerAddress == null
          ? null
          : await this.geocoderService.geocodeAddress(
              AddressHelper.getAddressDisplay(this.placerAddress)
            );
    } catch (error) {
      console.log(error);
    }
    const toRender: CoordinateLike[] =
      placerAddressCoordinates == null
        ? this.markers
        : [
            {
              lat: placerAddressCoordinates.lat,
              lng: placerAddressCoordinates.lng,
            },
            ...this.markers,
          ];
    this.employeeTourMapDirectionsCalculationService
      .calculateDirections(toRender, this.destroyThisComponent)
      .then((result: google.maps.DirectionsResult) => {
        this.calculateTotalDistance(result);
        return this.directionsRenderer.setDirections(result);
      })
      .catch((err) => console.error(err));
  }

  private calculateTotalDistance(result: google.maps.DirectionsResult): void {
    let total = 0;
    result.routes[0].legs.forEach((l) => {
      total += l.distance.value;
    });
    let roundedKm = (total * 0.001).toFixed(2);
    this.totalDistance = roundedKm.replace('.00', '').replace('.', ',') + ' km';
  }

  ngAfterViewInit(): void {
    this.addSubscription(this.agmMap.mapReady, (map: google.maps.Map) => {
      this.directionsRenderer.setMap(map);
    });
  }
}
